import { CompanyListModule } from './../companies/company-list/company-list.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouteRoutingModule } from './route-routing.module';
import { CampaignEditModule } from '../campaigns/campaign-edit/campaign-edit.module';
import { CampaignListModule } from '../campaigns/campaign-list/campaign-list.module';
import { CreativeEditModule } from '../creatives/creative-edit/creative-edit.module';
import { CreativeListModule } from '../creatives/creative-list/creative-list.module';
import { DealMarketplaceModule } from '../deals/deal-marketplace/deal-marketplace.module';
import { DealNegotiationModule } from '../deals/deal-negotiation/deal-negotiation.module';
import { ReportsModule } from '../reports/reports.module';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { WelcomeComponent } from '../welcome/welcome.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AppCommonModule } from 'src/app/common/common.module';
import { UnauthorizedComponent } from '../unauthorized/unauthorized.component';
import { AdvertisersModule } from '../advertisers/advertisers.module';

@NgModule({
  declarations: [DashboardComponent, PageNotFoundComponent, WelcomeComponent, UnauthorizedComponent],
  imports: [
    CommonModule,
    RouteRoutingModule,
    AppCommonModule,
    CompanyListModule,
    CampaignEditModule,
    CampaignListModule,
    CreativeEditModule,
    CreativeListModule,
    DealMarketplaceModule,
    DealNegotiationModule,
    ReportsModule,
    AdvertisersModule
  ]
})
export class RouteModule { }
